import TodoList from './TodoList';
import { markTodoComplete } from '../actions/todoActions';
import { hideCompletedTasks, showCompletedTasks } from '../actions/todoFolderViewStateActions';
import getSelectedFolderView from '../selectors/getSelectedFolderView';
import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import strings from 'owa-strings/owa-tasks-strings';
import { TodoItemDragData } from 'owa-todo-types/lib/types/TodoItemDragData';
import * as React from 'react';

const styles = require('./RecentlyCompletedTasks.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class RecentlyCompletedTasks extends React.Component<{}, {}> {
    render() {
        const recentlyCompletedTaskIds = getSelectedFolderView().recentlyCompletedTaskIds;
        if (recentlyCompletedTaskIds.length == 0) {
            return null;
        }

        const viewState = getSelectedFolderViewState();
        const toggleString = viewState.showCompletedTasks
            ? strings.hideRecentlyCompleted
            : strings.showRecentlyCompleted;
        const toggleAction = viewState.showCompletedTasks ? hideCompletedTasks : showCompletedTasks;
        const dropViewState = viewState.recentlyCompletedDropViewState;
        const chevronIconName = viewState.showCompletedTasks
            ? ControlIcons.ChevronDown
            : ControlIcons.ChevronRight;
        const isDragOver = dropViewState.isDragOver;

        return (
            <Droppable
                canDrop={this.canDrop}
                onDrop={this.onDrop.bind(this)}
                dropViewState={dropViewState}>
                <CommandButton
                    id="toggleRecentlyCompleted"
                    className={classNames(styles.toggleButton, {
                        bottomBorderDragOver: isDragOver,
                    })}
                    onClick={() => {
                        toggleAction();
                    }}
                    text={toggleString}
                    iconProps={{
                        iconName: chevronIconName,
                        styles: {
                            root: styles.chevronIcon,
                        },
                    }}
                />

                {viewState.showCompletedTasks && (
                    <TodoList todoIds={recentlyCompletedTaskIds} canDropOver={false} />
                )}
            </Droppable>
        );
    }

    private onDrop = (dragData: DragData, pageX: number, pageY: number, target?: HTMLElement) => {
        if (dragData.itemType !== DraggableItemTypes.Todo) {
            return;
        }

        const taskDragData = dragData as TodoItemDragData;
        if (taskDragData.ewsItemIds && taskDragData.ewsItemIds.length === 1) {
            markTodoComplete(taskDragData.ewsItemIds[0]);
        }
    };

    private canDrop = (dragInfo: DragData): boolean => {
        return dragInfo.itemType === DraggableItemTypes.Todo;
    };
}
